module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/Present')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAdio.present),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "present", $$v)
      },
      expression: "getSettingsAdio.present"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/adio/NoDevice'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/adio/ADIO'),
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalOut') + ' 0'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DO1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DO1", $$v)
      },
      expression: "getSettingsAdio.DO1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalIn') + ' 0'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DI1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DI1", $$v)
      },
      expression: "getSettingsAdio.DI1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalOut') + ' 1'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DO2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DO2", $$v)
      },
      expression: "getSettingsAdio.DO2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/DigitalIn') + ' 1'
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.DI2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "DI2", $$v)
      },
      expression: "getSettingsAdio.DI2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogIn')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.AI),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AI", $$v)
      },
      expression: "getSettingsAdio.AI"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogOut')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsAdio.AO),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AO", $$v)
      },
      expression: "getSettingsAdio.AO"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogLowerLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAdio.AI == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AILower),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AILower", $$v)
      },
      expression: "getSettingsAdio.AILower"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogUpperLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAdio.AI == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AIUpp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AIUpp", $$v)
      },
      expression: "getSettingsAdio.AIUpp"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogLowerLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": -10,
      "max": 140,
      "disabled": _vm.getSettingsAdio.AO == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AOLower),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AOLower", $$v)
      },
      expression: "getSettingsAdio.AOLower"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/adio/AnalogUpperLimit')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": -10,
      "max": 140,
      "disabled": _vm.getSettingsAdio.AO == 0
    },
    model: {
      value: (_vm.getSettingsAdio.AOUpp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAdio, "AOUpp", $$v)
      },
      expression: "getSettingsAdio.AOUpp"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99d5f2b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Adio.vue
// module id = 475
// module chunks = 1